import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { BusinessPartnerDisplayComponent } from 'app/shared/components/business-partner-display/business-partner-display.component';

/**
 * Business Partner Cell Renderer
 *
 * Wraps the BusinessPartnerDisplayComponent for displaying soldTo/shipTo
 * business partner information in smart-grid tables.
 *
 * @example
 * ```typescript
 * {
 *   colId: 'businessPartner',
 *   headerName: 'Pagador/Receptor',
 *   cellRenderer: BusinessPartnerCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-business-partner-cell-renderer',
  standalone: true,
  imports: [CommonModule, BusinessPartnerDisplayComponent],
  template: `
    <app-business-partner-display
      [soldTo]="soldTo"
      [shipTo]="shipTo"
      [customerType]="customerType"
      [showIcons]="true">
    </app-business-partner-display>
  `,
})
export class BusinessPartnerCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get soldTo(): any {
    return this.params.data?.soldTo ?? null;
  }

  get shipTo(): any {
    return this.params.data?.shipTo ?? null;
  }

  get customerType(): string | undefined {
    return this.params.data?.shipToType;
  }
}
